import { ArrowLeft, ArrowRight } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import BasicModal from 'src/components/BasicModal';
import { REVIEW_MEDIA_TYPE } from '../constants';
import PlayCircleOutlineRoundedIcon from '@mui/icons-material/PlayCircleOutlineRounded';
import classNames from 'node_modules/classnames/index';
import { ReviewerInfo } from '../Common';
import { IS_MOBILE } from 'src/utils/checkClientDeviceType';
import CustomizedButton from 'src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Button';
import { DEFAULT_IMAGE_OBJECT } from 'src/utils/constants';

export function ProductReviewModal({ modalState, setModalState, reviews }) {
  const [activeReviewMediaIndexLocal, setActiveReviewMediaIndexLocal] = useState(0);

  const activeReviewIndex = modalState?.activeReviewIndex;
  const activeReviewMediaIndex = modalState.reviewMediaIndex;
  const totalReview = reviews.length;
  const review = reviews[modalState.activeReviewIndex];

  const reviewMedia = review?.store_item_review_media || [];
  const hasMedia = !!reviewMedia?.length;

  const isPreviousReviewExists = activeReviewIndex > 0;
  const isNextReviewExists = activeReviewIndex < totalReview - 1;

  // these 4 are used only on Desktop
  const isPrevMediaExists = activeReviewMediaIndexLocal > 0;
  const isNextMediaExists = activeReviewMediaIndexLocal < reviewMedia?.length - 1;
  const isPrevButtonEnabled = isPrevMediaExists || isPreviousReviewExists;
  const isNextButtonEnabled = isNextMediaExists || isNextReviewExists;

  useEffect(() => {
    setActiveReviewMediaIndexLocal(activeReviewMediaIndex || 0);
  }, [review]);

  function goToPrevReview() {
    setModalState({
      ...modalState,
      reviewMediaIndex: 0,
      activeReviewIndex: modalState.activeReviewIndex - 1,
    });
  }

  function goToNextReview() {
    setModalState({
      ...modalState,
      reviewMediaIndex: 0,
      activeReviewIndex: modalState.activeReviewIndex + 1,
    });
  }

  function closeProductReviewModal() {
    setModalState({
      ...modalState,
      show: false,
    });
  }

  function handlePrevClick() {
    if (!isPrevButtonEnabled) {
      return;
    }

    if (isPrevMediaExists) {
      setActiveReviewMediaIndexLocal(activeReviewMediaIndexLocal - 1);
    } else {
      goToPrevReview();
    }
  }

  function handleNextClick() {
    if (!isNextButtonEnabled) {
      return;
    }

    if (isNextMediaExists) {
      setActiveReviewMediaIndexLocal(activeReviewMediaIndexLocal + 1);
    } else {
      goToNextReview();
    }
  }

  function renderMainMedia(media) {
    return (
      <div className="tw-flex tw-h-[342px] tw-w-[272px]   tw-flex-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-[8px] tw-object-contain md:tw-h-[518px] md:tw-w-[434px]">
        {media?.media_type === REVIEW_MEDIA_TYPE.VIDEO ? (
          <video
            src={media?.media_url}
            controls
            className="tw-flex tw-max-h-full tw-max-w-full tw-rounded-[8px]"
          />
        ) : (
          <img
            src={media?.media_url}
            className="tw-flex tw-max-h-full tw-max-w-full tw-rounded-[8px]"
          />
        )}
      </div>
    );
  }

  return (
    <BasicModal
      show={true}
      onClose={closeProductReviewModal}
      heading={'Product review'}
      headingClasses="!tw-px-[16px] md:!tw-px-[24px] !tw-overflow-visible"
      customClasses="!tw-w-full md:!tw-min-w-[780px] !tw-overflow-auto md:!tw-overflow-visible !tw-m-0"
    >
      {!IS_MOBILE && (
        <span
          onClick={handlePrevClick}
          className={classNames(
            'pointer tw-absolute -tw-left-[77px] tw-top-[50%] tw-flex tw-h-[35px] tw-w-[35px] -tw-translate-y-1/2 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-full tw-border-[3px] tw-border-solid tw-border-white tw-text-white',
            !isPrevButtonEnabled ? 'tw-opacity-40' : ''
          )}
        >
          <ArrowLeft fontSize="large" />
        </span>
      )}
      <div className={'tw-flex tw-h-full tw-w-full tw-flex-col md:tw-flex-row'}>
        {!IS_MOBILE && (
          <div className="tw-p-[24px]">
            {hasMedia ? (
              renderMainMedia(reviewMedia?.[activeReviewMediaIndexLocal])
            ) : (
              <div className="tw-flex tw-h-[342px] tw-w-[272px] tw-items-center tw-justify-center md:tw-h-[518px] md:tw-w-[434px]">
                <div className="tw-flex tw-w-[132px] tw-flex-col tw-items-center tw-gap-[16px]">
                  <img src={DEFAULT_IMAGE_OBJECT.image_url} className="tw-w-ful" />
                  <p className="tw-m-0 tw-text-[13px]/[18px] tw-font-medium tw-italic tw-text-[#969696]">
                    No media attatched
                  </p>
                </div>
              </div>
            )}
          </div>
        )}
        <div
          className={classNames(
            'tw-flex tw-flex-1 tw-flex-col tw-gap-[16px] tw-border-l tw-border-solid tw-border-[#111C361F] tw-p-[24px] tw-px-[20px]',
            IS_MOBILE && totalReview > 1 ? 'tw-pb-[80px]' : ''
          )}
        >
          <ReviewerInfo review={review} />
          <div className="tw-mb-[12px] tw-flex tw-gap-[12px] tw-text-[13px]/[18px] tw-font-normal tw-text-[#111C36]">
            <p className="!tw-m-0">{review?.review}</p>
          </div>
          {!IS_MOBILE && hasMedia && (
            <div className="tw-flex tw-flex-col tw-gap-[12px]">
              <p className="!tw-m-0 tw-text-[12px]/[18px] tw-font-medium tw-text-black">
                Media in this review
              </p>
              <div className="tw-flex tw-gap-[10px]">
                {reviewMedia?.map((media, index) => (
                  <div
                    key={index}
                    className={classNames(
                      'border-grey1 tw-relative tw-flex tw-h-[67px] tw-w-[67px] tw-cursor-pointer tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-[4px] tw-border-[2px] tw-border-solid tw-object-contain',
                      index === activeReviewMediaIndexLocal
                        ? 'tw-border-[#2B74D8]'
                        : 'tw-border-[#111C361F]'
                    )}
                    onClick={() => setActiveReviewMediaIndexLocal(index)}
                  >
                    <img
                      src={media?.thumbnail_url || media?.media_url}
                      className="tw-flex tw-max-h-full tw-max-w-full"
                    />
                    {media?.media_type === REVIEW_MEDIA_TYPE.VIDEO && (
                      <div className="tw-absolute tw-inset-0 tw-bg-[#00000059]">
                        <span className="tw-absolute tw-left-[50%] tw-top-[50%] tw-flex -tw-translate-x-1/2 -tw-translate-y-1/2 tw-text-white">
                          <PlayCircleOutlineRoundedIcon />
                        </span>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}
          {IS_MOBILE && (
            <div className="tw-flex tw-items-center tw-gap-[16px] tw-overflow-scroll tw-scroll-smooth tw-pb-[42px]">
              {reviewMedia?.map((media, index) => renderMainMedia(media))}
            </div>
          )}
        </div>
      </div>
      {IS_MOBILE && totalReview > 1 && (
        <div className="tw-fixed tw-bottom-0 tw-flex tw-w-full tw-justify-between tw-border-t tw-border-solid tw-border-[#111C361F] tw-bg-white tw-p-[20px]">
          <CustomizedButton
            disabled={!isPreviousReviewExists}
            variant="secondary"
            className={classNames(
              '!tw-h-[36px] !tw-border-[#2B74D8] !tw-px-[16px] !tw-py-[8px] !tw-text-[#2B74D8]',
              !isPreviousReviewExists ? 'tw-opacity-40' : ''
            )}
            onClick={isPreviousReviewExists && goToPrevReview}
          >
            Previous
          </CustomizedButton>
          <CustomizedButton
            disabled={!isNextReviewExists}
            variant="secondary"
            className={classNames(
              '!tw-h-[36px] !tw-border-[#2B74D8] !tw-px-[16px] !tw-py-[8px] !tw-text-[#2B74D8]',
              !isNextReviewExists ? 'tw-opacity-40' : ''
            )}
            onClick={isNextReviewExists && goToNextReview}
          >
            Next review
          </CustomizedButton>
        </div>
      )}
      {!IS_MOBILE && (
        <span
          onClick={handleNextClick}
          className={classNames(
            'pointer tw-absolute -tw-right-[77px] tw-top-[50%] tw-flex tw-h-[35px] tw-w-[35px] -tw-translate-y-1/2 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-full tw-border-[3px] tw-border-solid tw-border-white tw-text-white',
            !isNextButtonEnabled ? 'tw-opacity-40' : ''
          )}
        >
          <ArrowRight fontSize="large" />
        </span>
      )}
    </BasicModal>
  );
}
